import { toast } from 'react-toastify';
import i18next from 'i18next';

export const createErrorNotification = (
  message = i18next.t('promptbar:somethingWentWrong'),
) => {
  return toast.error(message, {
    position: 'top-right',
  });
};
